import type { Unsubscribe } from 'nanoevents'

/**
 * Creates a type-safe app events object from a cross-tab events runtime.
 * This utility wraps the cross-tab events with proper typing without using `any`.
 */
export function createAppEvents<TEventUnion extends { type: string }>(crossTab: {
  events: {
    on: (type: string, handler: (event: unknown) => void) => Unsubscribe
  }
  emit: <TType extends TEventUnion['type']>(
    type: TType,
    payload: Omit<Extract<TEventUnion, { type: TType }>, 'type'>,
  ) => void
  isLeader: () => boolean
}) {
  type EventHandler<T extends TEventUnion> = (event: T) => void

  return {
    on: <TType extends TEventUnion['type']>(
      type: TType,
      handler: EventHandler<Extract<TEventUnion, { type: TType }>>,
    ): Unsubscribe => {
      return crossTab.events.on(type, handler as (event: unknown) => void)
    },
    emit: <TType extends TEventUnion['type']>(
      type: TType,
      payload: Omit<Extract<TEventUnion, { type: TType }>, 'type'>,
    ): void => {
      crossTab.emit(type, payload)
    },
    isLeader: (): boolean => crossTab.isLeader(),
  }
}
